const wrapper = "_35sw17ot5tk";
const audioPlayer = "_35sa1dub0jh";

export { audioPlayer, wrapper };
import "./_infopage.style.linaria.module.css";
//# sourceMappingURL=_infopage.style.js.map
